module.exports = __webpack_public_path__ + "assets/img/b4-1.7722f0dc.png";